import React, { useContext } from 'react';
import { Helmet } from 'react-helmet';
import PodsUserDetail from './PodsUserDetail';
import { SidebarContext } from '../../../../context/SidebarContext';
import { getLocalStorageItem } from '../../../../utils/helper';
import { fetchCompanyPodsUserDetail } from './companyPodsApi';

/**
 * Company Shoorah Pods → one employee's/member's pods profile. Reuses the
 * shared detail page with the company-scoped fetcher (the backend 404s any
 * user who doesn't belong to this company).
 */
const CPodsUserDetail = () => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const userData = JSON.parse(getLocalStorageItem('userData') || '{}');
  const slug = userData?.slug;

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>User Pods Profile | Shoorah</title>
      </Helmet>
      <PodsUserDetail
        fetcher={fetchCompanyPodsUserDetail}
        backPath={`/${slug}/shoorah-pods/users`}
        backLabel={isB2BFansMode ? 'Back to Members' : 'Back to Employees'}
      />
    </div>
  );
};

export default CPodsUserDetail;
